import { render, staticRenderFns } from "./SpecificationLaborTable.vue?vue&type=template&id=08a0c050"
import script from "./SpecificationLaborTable.vue?vue&type=script&lang=js"
export * from "./SpecificationLaborTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports